var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popover',{ref:"dropdownMenuPopover",attrs:{"showHeader":true,"headerTitle":_vm.title,"placement":_vm.placement,"sizeClass":"popover-dropdown-menu"}},[_c('ul',{staticClass:"dropdown-menu-popover"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }